<template>
    <div class="all" ref="all">
		<!-- 筛选 -->
		<div class="screen clearfix">
			<!-- <h2 class="fl fs18">{{reportTit}}</h2> -->
			<div class="corm fl clearfix">
				<router-link class="element cp" :to="$baseUrl+'/competingReport'">报告列表</router-link>
				<router-link class="element cp" :to="$baseUrl+'/customTemplate'">自定义报告模板</router-link>
			</div>
			<div class="fr">
				<button class="btn btn-jbblue" @click="addTemplate();"><i class="icons add-icon"></i>新建竞对报告模板</button>
			</div>
		</div>
		<!-- 预警信息列表 -->
		<div class="warp mt20">
			<div class="warp-body">
				<table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
					<colgroup>
						<col width="55%"> 
						<col width="25%"> 
						<col width="15%">
					</colgroup>
					<thead>
						<tr>
							<th>系统模板</th>
							<th>创建时间</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in templateList">
							<td>{{item.tplName}}</td>
							<td>{{item.createTime}}</td>
							<td>
								<div class="table-all-icons">
									<span v-if="item.userId === 0">
										<i class="icons eye-icon cp" title="预览" @click="previewReport(item.id)"></i>
									</span>
									<span v-else>
										<i class="icons eye-icon cp" title="预览" @click="previewReport(item.id,item.tplType)"></i>
										<i class="icons edit-icon cp" title="修改" @click="editReport(item.id,item.tplType)"></i>
										<i class="icons del-icon cp" title="删除简报" @click="delReport(item.id)"></i>
									</span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import page from '../../components/page.vue';
export default {
    data() {
        return {
			templateList:[]
        }
    },
    mounted() {
		let that = this;
		that.getTemplateList();
    },
    beforeDestroy() {
        
    },
    methods: {
		//获取模板列表
		getTemplateList (){
			let that = this;
			that.$parent.loadModal(true,'数据加载中...');
			that.$api.post('monitor/compare/tpl-all-list',null,r =>{
				that.$parent.loadModal(false)
				that.$parent.returnCode(r,function(){
					that.templateList = r.data;
				})
			})
		},
		//新建竞对方案
		addTemplate(){
			this.$router.push({ path:''+this.$parent.baseUrl+'/addNewCustomTemplate'})
		},
		previewReport(id,type) {
            if(type == '1'){
                this.$router.push({ path:''+this.$parent.baseUrl+'/addCustomTemplate',query:{id:id,isPreview:true}})
            }else{
                this.$router.push({ path:''+this.$parent.baseUrl+'/addNewCustomTemplate',query:{id:id,isPreview:true}})
            }
		},
		delReport(id){
		    let that = this;
			that.$confirm('是否删除竞对报告模板？').then(() => {
				that.$api.get('monitor/compare/tpl-delete',{id:id},r=>{
					that.$parent.returnCode(r,function(){
                        that.$utils.alertText('删除成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'删除成功！'})
						that.getTemplateList()
					});
					
				});
		    });
		},
		editReport(id,type) {
            if(type == '1'){
                this.$router.push({ path:''+this.$parent.baseUrl+'/addCustomTemplate',query:{id:id}})
            }else{
                this.$router.push({ path:''+this.$parent.baseUrl+'/addNewCustomTemplate',query:{id:id}})
            }
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/page/competingReports/customTemplate.vue